<template>

  <div class="modal-container" v-show="visible">

    <transition>

      <div class="modal-content">

        <div class="modal_header">

          <div class="title_1">{{ title }}欢迎您</div>
          <div class="title_2">需车型匹配您爱车适用项目</div>

        </div>

        <div class="modal_main">
          <template v-if="isInputPhone==false">
            <div class="tips_text">门店服务过车辆请绑定</div>
            
            <div class="car-no-box" style="height: 80px"></div>
            <!--<div class="car-no-box" ref="carBox" style="height: 80px">
                            <span v-for="(item, index) in shadow" :Key="index"
                                  :class="{'active':clickedIndex === index}"
                                  @click="inputClick(index)">{{ item || (index === 7 ? '新' : '') }}</span>
            </div>-->

            <div class="binding-btn" @click="onBinding">车牌绑定</div>

          </template>

          <template v-if="isInputPhone==true">
            <div v-if="prefixNumber" class="tips_text">请输入手机号后4位验证</div>
            <div v-if="!prefixNumber" class="tips_text">请输入11位手机号码</div>

            <div class="car-no-box">
              <template v-for="(digit, index) in phoneNumberDigits">
                <template v-if="prefixNumber">
                  <span v-if="index<7" style="border: inherit; width: inherit;">{{ digit }}</span>
                  <span v-if="index>=7">
                                        <input type="tel"
                                               maxlength="2"
                                               :ref="'phoneNumberInput-' + index"
                                               v-model="phoneNumberDigits[index]"
                                               @input="onTelInput(index)"
                                               @click="onTelClick(index)"
                                               style="display: flex; border: none; width: 100%; text-align: center; "/>
                                    </span>
                </template>
                <template v-else>
                                    <span style="margin-right: 4px;">
                                        <input type="tel"
                                               maxlength="2"
                                               :ref="'phoneNumberInput-' + index"
                                               v-model="phoneNumberDigits[index]"
                                               @input="onTelInput(index)"
                                               @click="onTelClick(index)"
                                               style="display: flex; border: none; width: 100%; text-align: center; "/>
                                    </span>
                </template>
              </template>
            </div>

            <div class="binding-btn" @click="onVerify">确定验证</div>

          </template>


          <div class="sel-btn" @click="onAddCar()">未曾到店的请选择车型</div>
        </div>

      </div>

    </transition>

    <div class="modal-mask"></div>

    <transition>
      <div v-if="isInputPhone == false" class="vehicle-keyboard-drawer" ref="vehicleDrawer">

        <!--                <keyboard @close="closeClick" -->
        <!--                          :click-index="clickedIndex" -->
        <!--                          @add="addClick" -->
        <!--                          @del="delClick"></keyboard>-->
        <new-license @complete="licenseComplete"
                     :keyboard-visible="keyboardVisible"></new-license>
      </div>
    </transition>

    <!--        选择车型弹框-->
    <transition name="fade-drawer">
      <div class="select-car-drawer" v-if="selectCarVisible">
        <div class="drawer-header">
          请选择车型
          <span class="iconfont iconclose-bold" @click="onCloseAddCar"></span>
        </div>
        <div class="drawer-content">
          <iframe :src="addCarUrl" style="width: 100vw; border: 0; height: 100%;"></iframe>
        </div>
      </div>
    </transition>

  </div>


</template>

<script>
import NewLicenseKey from '@/components/NewLicenseKey.vue';
import {api} from "@/api/http";

export default {
  name: "PerfectVehicle",
  components: {
    'new-license': NewLicenseKey
  },
  props: {

    // 控制modal显示
    visible: {
      type: Boolean,
      default: false,
    },

    title: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      addCarUrl: '',
      selectCarVisible: false,
      keyboardVisible: false,

      shadow: new Array(8),
      clickedIndex: 0,
      carLicense: '',        // 车牌号
      isInputPhone: false,
      prefixNumber: '',
      phoneNumberDigits: ['', '', '', '', '', '', '', '', '', '', '']
    }
  },

  mounted() {
    var that = this;
    that.$nextTick(() => {
      // 确保dom异步加载完毕
      window.addEventListener('message', that.receiveMessageIframePage, false);
    })
  },
  methods: {
    receiveMessageIframePage(msg) {
      if (msg.data.type == 'vehicle-selector-success') {
        window.location.reload();
      }
    },
    onTelInput(index) {
      console.log("onTelInput", this.phoneNumberDigits)
      if (this.phoneNumberDigits[index].length == 2)
        this.phoneNumberDigits[index] = this.phoneNumberDigits[index][1];

      if (index == 10) return;
      var input = this.$refs['phoneNumberInput-' + (index + 1)][0];
      input.focus();
      input.setSelectionRange(input.value.length, input.value.length);
    },
    onTelClick(index) {
      var input = this.$refs['phoneNumberInput-' + index][0];
      input.setSelectionRange(input.value.length, input.value.length);
    },
    // 添加车型
    onSelectCar(carLicense) {
      this.addCarUrl = api.build('/Car/AddCar?licenseNo=' + carLicense);
      this.selectCarVisible = true;
    },
    // 关闭添加车型
    onCloseAddCar() {
      this.selectCarVisible = false;
      this.$emit('close')
    },

    // 添加车辆
    onAddCar() {
      if (this.carLicense.length < 7) {
        layer.msg("请输入车牌号");
        return;
      }

      this.keyboardVisible = false;
      this.onSelectCar(this.carLicense);
    },

    // 绑定车辆
    onBinding() {
      if (this.carLicense.length < 7) {
        layer.msg("请输入车牌号");
        return;
      }

      this.keyboardVisible = false;
      this.verifyLicenseNo(this.carLicense);
    },

    inputClick(i) {
      this.clickedIndex = i;
      this.keyboardVisible = true;
    },

    addClick(val) {
      this.shadow[this.clickedIndex] = val;
      this.clickedIndex += 1;
      if (this.clickedIndex > 7) this.clickedIndex = 7;
      this.carLicense = this.shadow.join('');
      console.log('carLicense', this.carLicense)
      this.$forceUpdate()
    },
    delClick(val) {
      this.shadow[this.clickedIndex] = '';
      this.clickedIndex -= 1;
      if (this.clickedIndex < 0) this.clickedIndex = 0;
      this.$forceUpdate()
    },
    licenseComplete(license) {
      this.shadow = license;
      this.carLicense = license.join('');
      console.log('license', license, this.carLicense);
      this.$forceUpdate();
    },
    closeClick() {
      console.log(this.shadow.join(''))
      this.carLicense = this.shadow.join('');
      console.log('车牌号', this.carLicense)
      this.keyboardVisible = false;
    },

    onVerify() {
      console.log("手机号码", this.phoneNumberDigits);
      if (this.phoneNumberDigits.filter(x => x.length == 0).length > 0) {
        layer.msg("请输入手机号");
        return;
      }
      this.bindLicenseNo(this.carLicense);
    },
    //车牌号验证
    verifyLicenseNo(licenseNo) {
      let that = this;
      that.$http.get('/MemberVehicle/VerifyLicenseNo?licenseNo=' + licenseNo)
          .success((message, res) => {
            console.log('车牌号验证：', res);
            if (res.code == 0) {
              this.prefixNumber = "";
              this.phoneNumberDigits = ['', '', '', '', '', '', '', '', '', '', ''];
              that.onSelectCar(that.carLicense);
              return;
            }

            if (res.code == 1) {
              this.isInputPhone = true;
              this.prefixNumber = res.prefixNumber;
              this.phoneNumberDigits[0] = this.prefixNumber[0];
              this.phoneNumberDigits[1] = this.prefixNumber[1];
              this.phoneNumberDigits[2] = this.prefixNumber[2];
              this.phoneNumberDigits[3] = "*";
              this.phoneNumberDigits[4] = "*";
              this.phoneNumberDigits[5] = "*";
              this.phoneNumberDigits[6] = "*";
              return;
            }

            if (res.code == 2) {
              this.isInputPhone = true;
              this.prefixNumber = "";
              this.phoneNumberDigits = ['', '', '', '', '', '', '', '', '', '', ''];
              return;
            }
          })
          .failed((code, message, data) => {
            console.error(message);
          })
          .error(err => {
            console.error(err);
          })
          .finally()
          .request()
    },
    //绑定车牌
    bindLicenseNo(licenseNo) {
      let that = this;

      var tailNumber = "";
      var phoneNumber = "";
      if (this.phoneNumberDigits.filter(x => x == '*').length > 0) {
        tailNumber += this.phoneNumberDigits[7];
        tailNumber += this.phoneNumberDigits[8];
        tailNumber += this.phoneNumberDigits[9];
        tailNumber += this.phoneNumberDigits[10];
      } else {
        phoneNumber = this.phoneNumberDigits.join("");
      }

      that.$http.post('/MemberVehicle/BindLicenseNo')
          .setParameters({licenseNo, tailNumber, phoneNumber})
          .success((message, res) => {
            console.log('绑定车牌：', res);
            if (res.code == 1) {
              layer.msg("绑定成功", function () {
                window.location.reload();
              });
              return;
            }

            that.onSelectCar(that.carLicense);
          })
          .failed((code, message, data) => {
            console.error('绑定车牌:', message);
            that.onSelectCar(that.carLicense);
          })
          .error(err => {
            console.error(err);
          })
          .finally()
          .request()
    }
  },


}
</script>

<style scoped lang="scss">

.modal-container {
  position: relative;


  .modal-mask {
    position: fixed;
    z-index: 4000;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, .4);

  }

  .modal-content {
    z-index: 4001;
    width: 9rem;
    background-color: #ff5121;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    // border-radius: 300% / 100% 100% 0 0;
    padding: .5rem .4rem;


    .modal_header {
      color: #fff;
      padding: 0 0 .4rem 0;
      font-size: .5rem;
      text-align: center;

      .title_1 {
      }

      .title_2 {
      }

    }

    .modal_main {
      width: 100%;
      background-color: #fff;
      padding: .4rem .3rem;
      border-radius: .2rem;

      .tips_text {
        font-size: .42rem;
        height: .8rem;
        display: flex;
        align-items: center;
      }

      .car-no-box {
        text-align: center;
        display: flex;
        padding: .5rem 0;
        justify-content: space-between;


        span {
          height: 1.2rem;
          width: 11.2%;
          border: 1px solid #e6e6e6;
          border-radius: .1rem;
          font-size: .45rem;
          display: flex;
          align-items: center;
          justify-content: center;

        }

        .active {
          // background-color: #CFD3DD;
          border: 1px solid #ff652b;
        }
      }


      .binding-btn {
        height: 1.2rem;
        border-radius: .6rem;
        background-color: #ff431b;
        color: #fff;
        font-size: .45rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .sel-btn {
        margin-top: .4rem;
        height: 1.2rem;
        border-radius: .6rem;
        background-color: #fff;
        color: #ff431b;
        font-size: .45rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #ff431b;
      }

    }
  }


  //
  .vehicle-keyboard-drawer {
    z-index: 4002;
    position: fixed;
    top: calc(50% - 25px);
    margin: 0 auto;
    left: 0;
    right: 0;

    .car_number_input {
      transform: scale(.9);
    }
  }

  .select-car-drawer {
    position: fixed;
    width: 100%;
    height: 95vh;
    z-index: 4002;
    bottom: 0;
    border-radius: .2rem;
    overflow: hidden;

    .drawer-header {
      height: 1.4rem;
      background-color: #eeeeee;
      color: #333;
      font-size: .4rem;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      .iconclose-bold {
        position: absolute;
        right: .4rem;
        font-size: .5rem;
      }

    }

    .drawer-content {
      height: calc(100% - 1.2rem);
    }
  }

}


</style>
<style lang="scss">
.vehicle-keyboard-drawer {
  .car_number_input {
    transform: scale(.9);
  }
}
</style>